<template>
  <div class="stock-area">
    <div class="select-items">
      <!-- <span>股票代號:</span>
      <el-input class="stock-id" size="medium" v-model="query.stock_id"></el-input>
      <el-button size="medium" @click="queryStock()">查詢</el-button> -->
    </div>

    <v-chart ref="strengthChart" class="chart" :options="stockOptions" />
<!-- 
    {{rawDataTW.map(x => x.percent)}}
    <hr>
    {{rawDataTW.map(x => x.average_percent_n)}}
     -->
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/polar";
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import "echarts/lib/chart/candlestick";
import { SMA } from 'technicalindicators'
export default {
  name: "CandlestickStrengthChart",
  components: {
    "v-chart": ECharts
  },
  computed: {
    chartData() {
      return this.rawDataTW.map(function(item) {
        return [+item.open, +item.close, +item.min, +item.max];
      });
    },
    closeData() {
      return this.chartData.map(item => item[1])
    },
    chartDates() {
      return this.rawDataTW.map(function(item) {
        return item.trading_date.slice(0, 10);
      });
    },
    chartVolumes() {
      return this.rawDataTW.map(item => Number(item.trading_volume.replace(/,/g,'')))
    },
    chartSeries() {
      let that = this;
      return this.chartTitle.map(title => {
          if(title.indexOf('MA') >= 0) {
            let frequency = Number(title.replace('MA',''));
            return {
              name: title,
              type: "line",
              data: that.calculateMA(frequency, that.chartData.map(item => item[1])),
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 1
              }
            }
          } 
          else if(title == '日K'){ 
            return {
              type: "candlestick",
              name: title,
              data: that.chartData,
              itemStyle: {
                color: "#FD1050",
                color0: "#0CF49B",
                borderColor: "#FD1050",
                borderColor0: "#0CF49B"
              }
            }
          }
          else if(title == 'SignalBuy') {
            return {
              name: 'SignalBuy',
              type: 'bar',
              xAxisIndex: 1,
              yAxisIndex: 1,
              data: that.rawDataTW.map(x => x.signal_buy), 
              itemStyle: { 
                color: '#00f'
              },
              barGap: '-100%'
            }
          }
          else if(title == 'SignalSell') {
            return {
              name: 'SignalSell',
              type: 'bar',
              xAxisIndex: 1,
              yAxisIndex: 1,
              data: that.rawDataTW.map(x => x.signal_sell), 
              itemStyle: { 
                color: '#f00'
              },
              barGap: '-100%'
            }
          }
          else if(title == 'Strength')
          {
            return {
              name: title,
              type: "line",
              data: that.rawDataTW.map(x => x.average_percent_n),
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 1
              },
              xAxisIndex: 1,
              yAxisIndex: 2,
              itemStyle: { 
                color: '#fa0'
              }
            }
          }
      })  
    },
    stockOptions() {
      return {
        title: {
          text: this.stockInfo === null ? '': `${this.stockInfo.stock_name} (${this.stockInfo.stock_id})`,
          // textAlign: 'center',
          textStyle: {
              // fontSize: 12,
              // fontWeight: 'normal',
              color: '#fff',
              width: '100%'
          },
          x: 'center',
          y: '20px'
        },
        backgroundColor: "#21202D",
        legend: {
          data: this.chartTitle,
          inactiveColor: "#777",
          textStyle: {
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false,
            type: "cross",
            lineStyle: {
              color: "#376df4",
              width: 2,
              opacity: 1
            }
          },
        },
        axisPointer: {
            link: {xAxisIndex: 'all'},
        },
        xAxis: [{
          type: "category",
          data: this.chartDates,
          axisLine: { lineStyle: { color: "#8392A5" } }
        },
        {
            type: 'category',
            gridIndex: 1,
            data: this.chartDates,
            min: 'dataMin',
            max: 'dataMax'
        }],
        yAxis: [{
          scale: true,
          axisLine: { lineStyle: { color: "#8392A5" } },
          splitLine: { show: false }
        }, {
          scale: true,
          gridIndex: 1,
          splitNumber: 2,
          axisLine: {
            lineStyle: { color: "#8392A5" } // volume color
          },
          axisLabel: {show: false},
          axisTick: {show: false},
          splitLine: {show: false}
        },{
          scale: true,
          gridIndex: 1,
          min: -2,
          max: 2,
          axisLine: {
            lineStyle: { color: "#8392A5" } 
          },
          axisTick: {show: false},
        }],
        grid: [{
          height: '50%'
        },{
          top: '73%',
          height: '16%',
          bottom: 80
        }],
        dataZoom: [
          {
            textStyle: {
              color: "#8392A5"
            },
            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            dataBackground: {
              areaStyle: {
                color: "#8392A5"
              },
              lineStyle: {
                opacity: 0.8,
                color: "#8392A5"
              }
            },
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          },
          {
            type: "inside",
            xAxisIndex: [0, 1]
          }
        ],
        animation: false,
        series: this.chartSeries
      }
    }
  },
  async mounted () {
    let that = this
    await this.queryStock();
    window.onresize = () => {
      return (() => {
          that.$refs.strengthChart.resize(); 
      })()
    }
  },
  data() {
    return {
      rawDataTW: [],
      chartTitle: ["日K", "MA20", "SignalBuy", "SignalSell", "Strength"],
      stockInfo: null,
      query: {
        stock_id: '0050'
      }
    };
  },
  methods: {
    async queryStock() {
      await this.getStocks();
      await this.getStockInfo();
    },
    async getStocks() {
      // let response = await this.axios.get(`/api/Strategy/GetAverageIncrease?stock_id=${this.query.stock_id}&averageDay=20&totalDay=360`)
      // let data = response.data;
      let data = require('../../../0050.json');
      let lastItem = null;
      this.rawDataTW = data.map((item, index)=> {
        item.signal_buy = 0;
        item.signal_sell = 0;
        if(index > 0 && lastItem.average_percent_n < 0 && item.average_percent_n > 0) {
          item.signal_buy = 1;
        }
        else if(index > 0 && lastItem.average_percent_n > 0 && item.average_percent_n < 0) {
          item.signal_sell = 1;
        }
        lastItem = item;
        return item;
      })
    },
    async getStockInfo() {
      // let response = await this.axios.get(`/api/Stock/GetStockInfoByStockId?stock_id=${this.query.stock_id}`)
      // this.stockInfo = response.data;
      this.stockInfo = {
        "id": "1",
        "stock_id": "0050",
        "stock_name": "元大台灣50",
        "type": "1",
        "type_name": "上市",
        "industry_category": "ETF",
        "note_date": "2020/02/28 11:17:03"
      }
    },
    calculateMA(dayCount, data) {
      let result = SMA.calculate({period : dayCount, values : data})
      return new Array(dayCount).fill('-').concat(result)
    },
  }
};
</script>

<style lang="stylus" scoped>

.stock-area
  width: 95%;
  max-width 960px
  margin: auto;

.echarts 
  width: 95%;
  max-width 960px
  height: 400px;

.chart 
  margin: 0 auto;

.select-items
  text-align left
  margin 10px 0px
  .el_input

  * + * 
    margin-left 10px
  .stock-id
    width 150px
</style>
